export default "__VITE_ASSET__CPFiU8Zh__"